export const formatTimestamp = (timestamp: string): string => {
  const now = new Date();
  const time = new Date(timestamp);

  const timeDiff = now.getTime() - time.getTime();
  const seconds = Math.floor(timeDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return "Just now";
  } else if (minutes < 60) {
    return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
  } else if (hours < 24) {
    return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  } else if (days === 1) {
    return "Yesterday";
  } else if (days < 7) {
    return `${days} day${days !== 1 ? "s" : ""} ago`;
  } else {
    return "";
  }
};

export function stringToColor(string: string) {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function stringAvatar(name: string) {
  const nameArr = name.split(" ");
  // eslint-disable-next-line prefer-destructuring
  const fName = nameArr[0][0];
  const lName = nameArr.length > 1 ? nameArr[1][0] : "";
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${fName}${lName}`,
  };
}
